/*
 * @Author: Ryan
 * @Date: 2026-01-19
 * @Description: 视频播放状态管理 - 实现页面单视频播放
 */
import { create } from 'zustand';

interface VideoPlayerState {
  /** 当前正在播放的视频 ID */
  currentPlayingId: string | null;
  /** 设置当前播放的视频 */
  setCurrentPlaying: (id: string | null) => void;
  /** 播放指定视频（会暂停其他视频） */
  play: (id: string) => void;
  /** 暂停当前视频 */
  pause: () => void;
  /** 检查指定视频是否正在播放 */
  isPlaying: (id: string) => boolean;
}

export const useVideoPlayerStore = create<VideoPlayerState>((set, get) => ({
  currentPlayingId: null,

  setCurrentPlaying: (id) => {
    set({ currentPlayingId: id });
  },

  play: (id) => {
    set({ currentPlayingId: id });
  },

  pause: () => {
    set({ currentPlayingId: null });
  },

  isPlaying: (id) => {
    return get().currentPlayingId === id;
  },
}));
